import React, {memo} from "react";
import cls from "./verification.module.scss";
import {UserProfileIcon} from "../../../assets/icons";
import cx from "classnames";
import {Icon} from "lb-components";

const UserVerificationIcon = ({style,bulletStyle})=>{

    return  (
        <div className={cls.userIcon} style={{...style}}>
            <Icon Icon={UserProfileIcon} style={{width:"100%",height:"100%"}}/>
            <div className={cx(cls.bullet,{
                [cls.verified]:true,
                [cls.notVerified]:false
            })}
            style={{...bulletStyle}}
            />
        </div>
    )
}

export default memo(UserVerificationIcon)
